import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AuthContextTwo } from "../../../contexts/AuthProviderTwo";
import LoaderInvoice from "../../Shared/pageLoaderGreen/LoaderInvoice";

const TutorPaymentGreenPaid = () => {
  const { userTwo } = useContext(AuthContextTwo);
  const [InvoiceMainData, setInvoiceMainData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const fetchData = async (page) => {
    setLoading(true);
    const url = `https://tutor-tree-server-1.vercel.app/mainPaymentBkash/${userTwo.email}?page=${page}&limit=10`;
    const res = await fetch(url);
    let data = await res.json();
    setInvoiceMainData(data.data);
    setTotalPages(data.totalPages);
    setLoading(false);
  };

  useEffect(() => {
    fetchData(page);
  }, [userTwo.email, page]);

  const formatDate = (dateString) => {
    // Extract the relevant parts of the date string
    const [datePart, timePart] = dateString.split('T');
    const [year, month, day] = datePart.split('-');
    
    // Construct the date in DD/MM/YYYY format
    const formattedDate = `${day}/${month}/${year}`;
    
    return formattedDate;
  };
  
  
  return (
    <div>
      {loading ? (
        <LoaderInvoice></LoaderInvoice>
      ) : (
        <div className="grid grid-cols-1 gap-5 m-5">
          {InvoiceMainData?.length > 0 ? (
            InvoiceMainData.map((invoice) => (
              <div
                key={invoice._id}
                className="flex flex-col shadow-sm justify-start items-start w-full py-6 px-5 bg-white rounded-lg"
              >
                <div className="flex flex-row justify-between items-center w-full">
                  <div>
                    <h1 className="lg:text-lg sm:text-sm text-green-900 font-montserrat text600">
                       Job Id : {invoice.userId}
                    </h1>
                    <h1 className="lg:text-lg sm:text-sm text-green-900 font-montserrat text600">
                       Payment ID : {invoice.paymentID}
                    </h1>
                    <h1 className="lg:text-lg sm:text-sm text-green-900 font-montserrat text600">
                       Bkash Invoice Id : {invoice.bkashInvoiceId} Tk
                    </h1>
                    <h1 className="lg:text-lg sm:text-sm text-green-900 font-montserrat text600">
                        Amount : {invoice.amount} Tk
                    </h1>
                    <h1 className="lg:text-lg sm:text-sm text-green-900 font-montserrat text600">
                        Bkash Invoice Id : {invoice.bkashInvoiceId} Tk
                    </h1>
                  </div>
                  <div>
                    <h1 className="lg:text-lg sm:text-sm text-green-900 font-montserrat text500">
                      Payment Recive Date : {formatDate(invoice.date)}
                    </h1>
                    
                  </div>
                </div>

                {/* <Link
                  to={`/dashboardTwo/TutorSubPaymentDetailsBkash/${invoice._id}`}
                >
                  <button className="mt-2 border border-green-900 text-green-900 hover:bg-green-900 hover:text-white duration-300 px-4 py-1 rounded-lg font-montserrat text-sm">
                    Click Here
                  </button>
                </Link> */}
              </div>
            ))
          ) : (
            <p>No data available</p>
          )}
        </div>
      )}
      <div className="flex justify-center items-center">
        <div className="flex justify-between mt-5 w-[300px]">
          <button disabled={page <= 1} onClick={() => setPage(page - 1)}>
            <img
              className="w-10"
              alt=""
              src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB4PSIwIiB5PSIwIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTEyIDUxMiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgY2xhc3M9IiI+PGcgdHJhbnNmb3JtPSJtYXRyaXgoLTEsLTEuMjI0NjQ2Nzk5MTQ3MzUzMmUtMTYsMS4yMjQ2NDY3OTkxNDczNTMyZS0xNiwtMSw1MTIsNTEyKSI+PHBhdGggZD0iTTI1NiAwQzExNC44MzcgMCAwIDExNC44MzcgMCAyNTZzMTE0LjgzNyAyNTYgMjU2IDI1NiAyNTYtMTE0LjgzNyAyNTYtMjU2UzM5Ny4xNjMgMCAyNTYgMHptNzkuMDgzIDI3MS4wODNMMjI4LjQxNiAzNzcuNzQ5QTIxLjI3NSAyMS4yNzUgMCAwIDEgMjEzLjMzMyAzODRhMjEuMjc3IDIxLjI3NyAwIDAgMS0xNS4wODMtNi4yNTFjLTguMzQxLTguMzQxLTguMzQxLTIxLjgyNCAwLTMwLjE2NUwyODkuODM1IDI1NmwtOTEuNTg0LTkxLjU4NGMtOC4zNDEtOC4zNDEtOC4zNDEtMjEuODI0IDAtMzAuMTY1czIxLjgyNC04LjM0MSAzMC4xNjUgMGwxMDYuNjY3IDEwNi42NjdjOC4zNDEgOC4zNDEgOC4zNDEgMjEuODIzIDAgMzAuMTY1eiIgZmlsbD0iIzAwODAwMCIgb3BhY2l0eT0iMSIgZGF0YS1vcmlnaW5hbD0iIzAwMDAwMCIgY2xhc3M9IiI+PC9wYXRoPjwvZz48L3N2Zz4="
            />
          </button>
          <span className="lg:text-lg sm:text-sm font-roboto">
            Page {page} of {totalPages}
          </span>
          <button
            disabled={page >= totalPages}
            onClick={() => setPage(page + 1)}
          >
            <img
              className="w-10"
              alt=""
              src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB4PSIwIiB5PSIwIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTEyIDUxMiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgY2xhc3M9IiI+PGc+PHBhdGggZD0iTTI1NiAwQzExNC44MzcgMCAwIDExNC44MzcgMCAyNTZzMTE0LjgzNyAyNTYgMjU2IDI1NiAyNTYtMTE0LjgzNyAyNTYtMjU2UzM5Ny4xNjMgMCAyNTYgMHptNzkuMDgzIDI3MS4wODNMMjI4LjQxNiAzNzcuNzQ5QTIxLjI3NSAyMS4yNzUgMCAwIDEgMjEzLjMzMyAzODRhMjEuMjc3IDIxLjI3NyAwIDAgMS0xNS4wODMtNi4yNTFjLTguMzQxLTguMzQxLTguMzQxLTIxLjgyNCAwLTMwLjE2NUwyODkuODM1IDI1NmwtOTEuNTg0LTkxLjU4NGMtOC4zNDEtOC4zNDEtOC4zNDEtMjEuODI0IDAtMzAuMTY1czIxLjgyNC04LjM0MSAzMC4xNjUgMGwxMDYuNjY3IDEwNi42NjdjOC4zNDEgOC4zNDEgOC4zNDEgMjEuODIzIDAgMzAuMTY1eiIgZmlsbD0iIzAwODAwMCIgb3BhY2l0eT0iMSIgZGF0YS1vcmlnaW5hbD0iIzAwMDAwMCIgY2xhc3M9IiI+PC9wYXRoPjwvZz48L3N2Zz4="
            />
          </button>
        </div>
      </div>
    </div>
  );
};

export default TutorPaymentGreenPaid;
